module.exports = __webpack_public_path__ + "img/14.fb299db7.jpeg";